import React from 'react'

import FaArrowCircleORight from 'react-icons/lib/fa/arrow-circle-o-right'
import FaEnvelope from 'react-icons/lib/fa/envelope'
import FaMapMarker from 'react-icons/lib/fa/map-marker'
import { getTranslate, getActiveLanguage } from 'react-localize-redux';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";
import FaCopyright from "react-icons/lib/fa/copyright"
import FaFacebookOfficial from "react-icons/lib/fa/facebook-official"
import FaLinkedinSquare from "react-icons/lib/fa/linkedin-square"
import FaTwitterSquare from "react-icons/lib/fa/twitter-square"

const Footer = (props) => {

    const { translate, currentLocale } = props
    return (
        <footer className="main-footer">
            <div className=" footer--content">
                <h3>{translate('siteMap')}</h3>
                <div className="footer-body">
                    <div className="footer-item">
                        <h5>{translate('pages')}</h5>
                        <Link to={"/" + currentLocale.code}>{translate('main')}</Link>
                        <Link to={"/" + currentLocale.code + "/" + translate("termsandconditionsUrl")}>{translate('termsandconditions')}</Link>
                        <Link to={"/" + currentLocale.code + "/" + translate("salespointsUrl")}>{translate('salespoints')}</Link>
                    </div>
                    <div className="footer-item item-two">
                        <Link to={"/" + currentLocale.code + "/" + translate("aboutusUrl")}>{translate('aboutus')}</Link>
                        <a onClick={() => window.open(`${window.config.env.EXTERNAL_LINKS}`)} className="green" target="_blank"> <FaArrowCircleORight /> {translate('agents')}</a>
                        <Link to={"/" + currentLocale.code + "/" + translate("contactusUrl")}>{translate('contact')}</Link>
                    </div>
                    <div className="footer-item">
                        <h5>{translate('connectUs')}</h5>
                        <a className="grey"><FaMapMarker className="green" /> {translate('address')}:<span className="white"> {translate('addressValue')}</span></a>
                        <a className="grey" href="mailto:info@tpl.ge"><FaEnvelope className="green" /> {translate('address')}:<span className="white footer-email"> info@tpl.ge</span></a>
                        <div className="footer-Icons">
                            <a href="https://www.facebook.com/tplgeogia.ge/" target="_blank" title="Follw Us On Facebook"> <FaFacebookOfficial /></a>
                            <a href="https://www.linkedin.com/company/tpl-georgia/" target="_blank"> <FaLinkedinSquare /> </a>
                            <a href="https://www.facebook.com/tplgeogia.ge/" target="_blank"><FaTwitterSquare /></a>
                        </div>
                    </div>
                    <div className="footer-item">
                        <h5>{translate('hotLine')}</h5>
                        <a href="tel:+995322301111">+995 322 301111</a>
                    </div>
                </div>
            </div>
            <div className="allRightsReserved">
                <span className="allRightsReservedItems">
                    <p></p>
                    <p>{translate("GeorgianInsuranceAgency")}</p>
                    <p><FaCopyright /> {translate("Allrightsreserved")}</p>
                </span>
            </div>
        </footer >
    )
}

const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
    currentLocale: getActiveLanguage(state.locale)
});

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js